var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacancies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1778 16.4208C16.7732 16.2776 16.5654 15.965 16.4603 15.7126C17.0427 15.3459 17.3453 14.4759 17.3453 13.8148C17.3453 12.9554 16.6824 12.2593 15.8638 12.2593C15.046 12.2593 14.3823 12.9554 14.3823 13.8148C14.3823 14.4763 14.6857 15.347 15.2688 15.713C15.1638 15.9673 14.9567 16.2827 14.5534 16.42C13.8423 16.6619 13.1481 16.7408 13.1481 17.9631V18.4815H18.5802V17.9631C18.5802 16.7591 17.9165 16.6829 17.1778 16.4208Z",
    fill: "#214BA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8424 22.684C17.3605 22.6837 18.8349 22.1755 20.0307 21.2403L23.7906 25L25 23.7907L21.2401 20.031C22.1758 18.8351 22.6844 17.3604 22.6847 15.842C22.6847 12.0695 19.6151 9 15.8424 9C12.0697 9 9 12.0695 9 15.842C9 19.6145 12.0697 22.684 15.8424 22.684ZM15.8424 10.7105C18.6725 10.7105 20.9741 13.012 20.9741 15.842C20.9741 18.672 18.6725 20.9735 15.8424 20.9735C13.0122 20.9735 10.7106 18.672 10.7106 15.842C10.7106 13.012 13.0122 10.7105 15.8424 10.7105Z",
    fill: "#075BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancies);
export default __webpack_public_path__ + "static/media/vacancies.a86d388a69cb874f666f688ffad417eb.svg";
export { ForwardRef as ReactComponent };